module.exports = __webpack_public_path__ + "static/media/re2.68e04371.jpg";